export default __webpack_public_path__ + "static/media/2408022.b395024b.webp";